import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, Observable, Subject, Subscription, catchError, concatMap, from, map, mergeMap, takeUntil, tap, toArray } from 'rxjs';
import { CommentObject } from '../models/comment.model';
import { MFilesItem } from '../models/mfiles-item.model';
import { Property } from '../models/property.model';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';
import { ExternalShareService } from '../services/external-share.service';
import { MFilesService } from '../services/mfiles.service';
import { PageService } from '../services/page.service';

declare var $: any;

@Component({
	selector: 'app-external-file-share',
	templateUrl: './external-file-share.component.html',
	styleUrls: ['./external-file-share.component.css']
})
export class ExternalFileShareComponent implements OnInit {
	@ViewChild('deleteDialog') private deleteDialog: TemplateRef<any>;
	@ViewChild('viewerModal') private viewerModal: TemplateRef<any>;
	@ViewChild('uploadProgressModal') private uploadProgressModal: TemplateRef<any>;
	@ViewChild('downloadProgressModal') private downloadProgressModal: TemplateRef<any>;

	modalRef: BsModalRef;
	viewerModalRef: BsModalRef;
	uploadProgressModalRef: BsModalRef;

	token = '';
	sharedItem: any;
	sharedItems = [];
	sharedItemsLoaded = false;
	permissions = [];
	title = 'M-Connect Share';
	isAuthed = false;
	isValid = false;
	loadingTitle = true;

	loading = true;

	error = false;
	errorMessage = '';

	loadedTypes = [];
	objectTypes = [];
	objectTypeIcons = {};
	useMfilesIcons = true;

	dataView = {
		viewContents: {
			columns: [
				{ 'id': -1, 'name': 'Name', 'position': 0, 'width': 500 }
			]
		}
	};

	displayTab = 'viewer';

	uploadClass = -1;
	uploadFiles = [];
	uploadItem: number;
	uploadIndex: number;
	showUpload = false;
	showRevision = false;

	deleteName = '';
	deleteType: number;
	deleteItem: number;

	autoPreviewDocument = true;
	autoSelect = false;
	autoSelectType = 0;
	autoSelectId: number;
	firstSelectOccurred = false;

	uploadFormValid = false;
	uploadFormProperties: Property[][];

	vaultProperties: any[];
	formData = [];
	editingProperties = false;
	editProperties: any[];
	optionLists = [];
	optionListTotal = 0;
	optionListLoaded = 0;

	comments: CommentObject[];
	commentsCount = 0;
	loadingComments = false;
	newComment = new CommentObject();

	uneditableProps = [20, 21, 22, 23, 24, 25, 30, 31, 32, 40, 81, 89, 100, 101];
	docEditProps = [];
	atLeastOneEditProp = false;
	loadingProperties = false;

	coauthorEnabled = false;

	downloadedUrl: SafeUrl;

	selectedDocumentIndex = -1;
	selectedMemberIndex = -1;
	selectedFileIndex = -1;
	viewerModalSettings = {
		displayViewer: true,
		displayMetadata: false,
		displayComments: false,
		displayWorkflow: false,
		disableAnnotations: true
	};

	viewableFileTypes: string[] = [
		"pdf", "doc", "dot", "docx", "docm", "dotx", "dotm", "rtf", "xls", "xlt", "xlsx", "xlsm", "xltx", "xltm",
		"ppt", "pot", "pps", "pptx", "pptm", "potx", "potm", "ppsx", "ppsm", "odt", "ott", "fodt", "ods", "ots",
		"fods", "odp", "otp", "fodp", "odf", "odg", "otg", "fodg", "dwg", "dxf", "dwf", "dgn", "html", "htm",
		"xhtml", "xhtm", "msg", "eml", "txt", "csv", "dcm", "dicom", "dcim", "dicm", "tif", "tiff", "jpg", "jpeg",
		"jp2", "jpc", "gif", "png", "psd", "psb", "bmp", "dib", "pct", "pic", "pict", "wmf", "emf", "pcx", "dcx",
		"ras", "pcd", "tga", "tpic", "cal", "cals", "ico", "cur", "ncr", "xwd", "sgi", "wbmp", "sct", "wpg", "xbm",
		"pbm", "pgm", "ppm", "img", "cut", "vsd", "vsdx"
	];

	uploadsCommitting: boolean = false;
	uploadProgressStats: any = {};
	microserviceUploadSubscription: Subscription;
	uploadProgressMessage: string = '';
	loadingDownloadAll: boolean;
	loadingDownloadSelected: boolean;
	allDocsSelected: boolean;
	selectedDocs: any[];
	docToDownload: any;
	downloadSubscription: Subscription;
	downloadProgress: number;

	constructor(
		private modalService: BsModalService,
		private route: ActivatedRoute,
		private mfilesService: MFilesService,
		private externalShareService: ExternalShareService,
		public configService: ConfigurationService,
		private pageService: PageService,
		private domSanitizer: DomSanitizer,
		public authService: AuthService,
		private toastr: ToastrService,
		private router: Router
	) { }

	ngOnInit(): void {
		this.configService.list(false).subscribe((result) => {
			for (const config of result) {
				if (config.name === 'useMfilesIcons') {
					this.useMfilesIcons = config.value.toLowerCase() === 'true';
				} else if (config.name === 'coauthorEnabled') {
					this.coauthorEnabled = config.value.toLowerCase() === 'true';
				} else if (config.name === 'autoPreviewDocument') {
					this.autoPreviewDocument = config.value.toLowerCase() === 'true';
				}
			}
		});

		this.route.queryParams.subscribe(params => {
			if (params.token) {
				this.sharedItemsLoaded = false;
				this.token = params.token;

				this.externalShareService.init(this.token).subscribe(() => {
					this.loadShare();

					this.externalShareService.getVaultProperties(this.token).subscribe((result) => {
						this.vaultProperties = result;
					});

					this.externalShareService.getObjectTypes(this.token).subscribe((result) => {
						result.forEach((objectType) => {
							this.objectTypes[objectType.id] = objectType;
						});
					});
				});
			}
			if (params.type) {
				if (typeof params.type === 'object') {
					this.autoSelectType = params.type[0];
				} else {
					this.autoSelectType = params.type;
				}
			}
			if (params.id) {
				if (typeof params.id === 'object') {
					this.autoSelectId = params.id[0];
				} else {
					this.autoSelectId = params.id;
				}
			}
		});

		if (this.authService.isAuthenticated()) {
			this.newComment.user = this.authService.getActiveUsername();
			this.externalShareService.markViewed(this.token).subscribe((result) => {
			});
		}
	}

	loadShare() {
		if (this.autoSelectId) {
			this.firstSelectOccurred = false;
			this.autoSelect = true;
		}

		this.loading = true;
		this.error = false;

		this.sharedItemsLoaded = false;
		this.sharedItems = [];
		this.sharedItem = null;
		this.editingProperties = false;
		this.showRevision = false;
		this.showUpload = false;

		this.externalShareService.getInfo(this.token).subscribe((result) => {
			if (!result.isAuthed && result.requiresAuth) {
				const queryParams = {
					url: this.route.snapshot.url
				};
				if (this.route.snapshot.queryParams.token) {
					queryParams['token'] = this.route.snapshot.queryParams.token;
				}

				this.router.navigate(['/login'], { queryParams });
			} else {
				this.permissions = result.permissions;
				if (this.permissions.indexOf(4) > -1) {
					this.permissions.splice(this.permissions.indexOf(4), 1);
				}
				this.uploadClass = result.uploadClass;
				this.title = result.title;
				this.isAuthed = result.isAuthed;
				this.isValid = result.isValid;
				this.loadingTitle = false;
			}
		});

		this.externalShareService.getItems(this.token).subscribe((result) => {
			this.sharedItems = result;

			for (let i = 0; i < this.sharedItems.length; i++) {
				if (!this.sharedItems[i].display) {
					this.sharedItems.splice(i, 1);
					i = i - 1;
				} else {
					this.getIcon(this.sharedItems[i].objVer.type);
				}
			}

			this.sharedItems.sort((a, b) => (a.name > b.name) ? 1 : -1);

			this.sharedItemsLoaded = true;
			this.loading = false;

			if (this.autoSelectId) {
				this.autoSelect = true;

				for (let i = 0; i < this.sharedItems.length; i++) {
					if (this.autoSelectType == this.sharedItems[i].type && this.autoSelectId == this.sharedItems[i].id) {
						const defaultItem = this.sharedItems[i];
						if (this.isViewableFileType(defaultItem)) {
							this.externalObjectSelected(defaultItem, i, 0, 0);
							break;
						}
					}
				}

			} else if (this.sharedItems.length === 1 && this.autoPreviewDocument) {
				this.autoSelect = true;
				this.autoSelectId = this.sharedItems[0].id;
				const defaultItem = this.sharedItems[0];
				if (this.isViewableFileType(defaultItem)) {
					this.externalObjectSelected(defaultItem, 0, 0, 0);
				}
			} else {
				this.autoSelect = false;
			}

			this.autoSelectType = undefined;
			this.autoSelectId = undefined;
		});
	}

	isViewableFileType(item: any) {
		const extension: string = item.extension;
		if (extension !== null && extension !== undefined && extension !== "") {
			if (!this.viewableFileTypes.includes(extension)) {
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

	setCommentsCount(comments: CommentObject[]) {
		this.commentsCount = 0;
		if (comments.length > 0) {
			this.commentsCount = comments[0].commentCount;
		}
	}

	getIcon(type: number) {
		if (type !== 0 && this.useMfilesIcons && !this.loadedTypes.includes(type)) {
			this.loadedTypes.push(type);
			this.externalShareService.getObjectTypeIcon(this.token, type).subscribe((imageResult) => {
				if (imageResult.body && imageResult.body.size !== 0) {
					const reader = new FileReader();
					reader.onloadend = (e) => {
						this.objectTypeIcons[type] = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
					};
					reader.readAsDataURL(imageResult.body);
				} else {
					this.objectTypeIcons[type] = undefined;
				}
			});
		}
	}

	externalObjectSelected(selectedItem: any, docIndex: number, memberIndex: number, fileIndex: number) {
		this.sharedItem = selectedItem;
		if (!this.firstSelectOccurred) {
			this.firstSelectOccurred = true;
		} else {
			this.autoSelect = false;
		}

		const currentIndex = this.selectedDocumentIndex;
		if (docIndex > -1) {
			this.selectedDocumentIndex = docIndex;
		} else {
			this.selectedDocumentIndex = -1;
		}
		this.selectedMemberIndex = memberIndex;
		this.selectedFileIndex = fileIndex;

		const context = {
			itemId: selectedItem.members ? selectedItem.members[memberIndex].id : selectedItem.id,
			type: 0,
			fileIndex: fileIndex,
			version: selectedItem.members ? selectedItem.members[memberIndex].version : selectedItem.version,
		};

		if (currentIndex !== this.selectedDocumentIndex) {
			this.loadDocProperties();
		}

		this.closeViewerModal();
		this.openViewerModal(this.viewerModal, 'xl tender');

		setTimeout(() => {
			this.pageService.documentSelectionOccurred.emit(context);
		}, 500);
	}

	openViewerModal(template: TemplateRef<any>, size: string) {
		this.displayTab = 'viewer';
		this.viewerModalRef = this.modalService.show(
			template,
			{ backdrop: 'static', class: 'modal-' + size, animated: false }
		);
	}

	openModal(template: TemplateRef<any>, size: string) {
		this.modalRef = this.modalService.show(
			template,
			{ class: 'modal-' + size, backdrop: 'static', animated: false }
		);
	}

	cancelUpload() {
		this.uploadItem = null;
		this.uploadIndex = null;
		this.showUpload = false;
		this.showRevision = false;
		this.uploadFiles = [];

		this.mfilesService.cancelMicroserviceUpload.next(null);
		this.mfilesService.microserviceUploadProgress = {};
		this.uploadProgressStats = {};
		this.uploadProgressMessage = '';
		this.closeModal();
	}

	openCheckinForRevision(itemId: number, fileIndex: number) {
		this.uploadItem = itemId;
		this.uploadIndex = fileIndex;
		this.showRevision = true;
	}

	onUploadQueueChange(queue: any) {
		this.uploadFiles = queue;
	}

	uploadRevision() {
		this.loading = true;

		this.mfilesService.isMicroserviceAvailable().subscribe((available) => {
			if (available) {
				this.mfilesService.microserviceUploadProgress = this.uploadProgressStats;
				this.openModal(this.uploadProgressModal, 'md');

				this.microserviceUploadSubscription = new Observable()
					.pipe(
						tap(() => this.authService.isUploading = true),
						concatMap((props) => this.externalShareService.prepareUploadRevision(this.token, this.uploadItem, this.uploadIndex)),								// Makes the prepareUploadRevision calls in order and returns the result in order.
						mergeMap((result, index) => this.mfilesService.microserviceUpload(result, this.uploadFiles[0].file, true)
							.catch(err => {																								// If an error occurs while the file is uploading to the microservice, this catches it and ensures the rest of the uploads don't get canceled.
								if (err.file) {
									this.uploadProgressStats[err.file.name] = 'ERROR';													// UI looks for this value and uses it to determine if the error message should be shown. Don't remove it.
								}
								return EMPTY;
							}), 3),																										// Starts uploading the files to the microservice. The 3 tells angular to limit the number of concurrent uploads to 3.
						mergeMap((result) => result, 1),																				// Intermediate step since microserviceUpload() returns a Promise with an Observable in it. This just returns the enclosed Observable.
						toArray(),																										// Merge all of the microserviceUpload results into an array.
						tap(() => {
							this.uploadsCommitting = true;
						}),
						mergeMap(() => this.externalShareService.postUploadRevision(this.token, this.uploadItem, this.uploadIndex)			// Calls the postUploadRevision with all of the new objects in M-Files.
							.pipe(
								catchError(err => {
									this.toastr.error('An error occurred while attempting to upload your files into M-Files. Please try again later.');
									return EMPTY;
								})
							), 1),
						tap(() => {
							this.uploadsCommitting = false;
							this.authService.isUploading = false;
							this.mfilesService.emitUploadProgress('all', 100);
						}))								// The upload to M-Files is now 100% complete.
					.subscribe({
						next: (res) => { },
						error: (err) => { },
						complete: () => {
							this.loadShare()

							setTimeout(() => {
								this.closeModal();

								this.uploadItem = -1;
								this.uploadIndex = -1;
								this.uploadFiles = [];
								this.mfilesService.microserviceUploadProgress = {};
								this.uploadProgressStats = {};
							}, 1500);
						}
					});
			} else {
				this.externalShareService.uploadRevision(this.token, this.uploadItem, this.uploadIndex, this.uploadFiles[0].file).subscribe((result) => {
					this.uploadItem = -1;
					this.uploadIndex = -1;
					this.uploadFiles = [];
					this.loadShare();
				});
			}
		});
	}

	openVerifyDelete(name: string, itemType: number, itemId: number) {
		this.deleteName = name;
		this.deleteType = itemType;
		this.deleteItem = itemId;
		this.openModal(this.deleteDialog, 'md');
	}

	deleteObject() {
		this.modalRef.hide();
		this.loading = true;
		this.externalShareService.deleteObject(this.token, this.deleteType, this.deleteItem, true).subscribe((result) => {
			this.deleteType = -1;
			this.deleteItem = -1;
			this.loadShare();
		});
	}

	onFormChange(forms: UntypedFormGroup[]) {
		let valid = true;
		if (forms.length === 0) {
			this.uploadFormValid = false;
		}
		for (const form of forms) {
			if (!form.valid) {
				valid = false;
				break;
			}
		}
		this.uploadFormValid = valid;
	}

	onPropertiesChange(formProperties: Property[][]) {
		this.uploadFormProperties = formProperties;
	}

	create() {
		this.loading = true;
		this.doCreateUpload(0);
	}

	openUploader() {
		document.getElementById("uploader").click();
	}

	uploadFile(e: any) {
		let files: File[] = Array.from(e.target.files);

		if (files.length === 0) return;

		this.loading = true;

		this.mfilesService.cancelMicroserviceUpload.subscribe(() => {
			this.microserviceUploadSubscription.unsubscribe();
			e.target.value = '';	// Need this to fix a bug where the system file explorer doesn't open if the user tries to open it a second time
			this.loading = false;
		});

		this.externalShareService.getClassProperties(this.uploadClass, this.token).subscribe((uploadProperties: any[]) => {
			this.mfilesService.isMicroserviceAvailable().subscribe((available) => {
				if (available) {
					const uploadProps = [];
					let maxConcurrentUploads: number = 3;
					let filesUploading: number = 0;
					let totalFiles: number = files.length;

					for (let i = 0; i < files.length; i++) {
						const file: File = files[i];

						if (file.size > 0) {
							this.uploadProgressStats[file.name] = 0;	// Init the progress stats for this file while we're iterating through the files
						} else {
							this.uploadProgressStats[file.name] = 'EMPTY';
							files.splice(i, 1);		// If the file is empty, remove it and don't try to upload it. A message will be displayed to the user for this file.
							totalFiles--;
							i--;
							continue;
						}

						if (file.size >= (1024 * 1024 * 200)) { // 200MB
							maxConcurrentUploads = 1;
						}

						const props = [];
						for (const prop of uploadProperties) {
							const propCopy = JSON.parse(JSON.stringify(prop));
							if (propCopy.id === 0) {
								propCopy.value = this.getFileName(file.name);
							}
							props.push(propCopy);
						}
						uploadProps.push(props);
					}

					this.mfilesService.microserviceUploadProgress = this.uploadProgressStats;
					this.openModal(this.uploadProgressModal, 'md');

					this.microserviceUploadSubscription = from(uploadProps)
						.pipe(
							tap(() => this.authService.isUploading = true),
							concatMap((props) => this.externalShareService.prepareCheckinNew(this.token, props)),								// Makes the prepareShareItemCheckin calls in order and returns the result in order.
							mergeMap((result, index) => {
								filesUploading += 1;
								this.uploadProgressMessage = `Uploading ${filesUploading}/${totalFiles}`;

								return this.mfilesService.microserviceUpload(result, files[index])
									.catch(err => {																								// If an error occurs while the file is uploading to the microservice, this catches it and ensures the rest of the uploads don't get canceled.
										if (err.file) {
											this.uploadProgressStats[err.file.name] = 'ERROR';													// UI looks for this value and uses it to determine if the error message should be shown. Don't remove it.
										}
										return EMPTY;
									})
							}, maxConcurrentUploads),																										// Starts uploading the files to the microservice. The 3 tells angular to limit the number of concurrent uploads to 3.
							mergeMap((result) => result, 1),																				// Intermediate step since microserviceUpload() returns a Promise with an Observable in it. This just returns the enclosed Observable.
							toArray(),																										// Merge all of the microserviceUpload results into an array.
							tap(() => {
								this.uploadsCommitting = true;
								this.uploadProgressMessage = 'Finalizing';
							}),
							mergeMap((uploadResults) => this.externalShareService.postCheckinNewMultiple(this.token, uploadResults)			// Calls the postShareItemCheckinMultiple with all of the new objects in M-Files.
								.pipe(
									catchError(err => {
										this.toastr.error('An error occurred while attempting to upload your files into M-Files. Please try again later.');
										return EMPTY;
									})
								), 1),
							tap(() => {
								this.uploadsCommitting = false;
								this.authService.isUploading = false;
								this.mfilesService.emitUploadProgress('all', 100);
								this.uploadProgressMessage = 'Complete';
							}))								// The upload to M-Files is now 100% complete.
						.subscribe({
							next: (res) => { },
							error: (err) => { },
							complete: () => {
								this.loadShare()

								setTimeout(() => {
									this.closeModal();

									e.target.value = '';	// Need this to fix a bug where the system file explorer doesn't open if the user tries to open it a second time

									this.mfilesService.microserviceUploadProgress = {};
									this.uploadProgressStats = {};
									this.uploadProgressMessage = '';
								}, 1500);
							}
						});
				} else {
					const props = [];

					for (let i = 0; i < files.length; i++) {
						const file: File = files[i];

						for (const prop of uploadProperties) {
							const propCopy = JSON.parse(JSON.stringify(prop));
							if (propCopy.id === 0) {
								propCopy.value = this.getFileName(file.name);
							}
							props.push(propCopy);
						}
					}

					this.externalShareService.checkinNew(this.token, props, e.target.files[0]).subscribe((result) => {
						this.loadShare();
					});
				}
			});
		});

	}

	closeModal() {
		if (this.modalRef) {
			this.modalRef.hide();
			this.modalRef = null;
		}
	}

	getFileName(fileName: string): string {
		const parts = fileName.split('.');
		parts.pop();
		return parts.join('.');
	}

	doCreateUpload(i: number) {
		this.mfilesService.isMicroserviceAvailable().subscribe((available) => {
			if (available) {
				this.externalShareService.prepareCheckinNew(this.token, this.uploadFormProperties[i]).subscribe(async (result) => {
					const response = await this.mfilesService.microserviceUpload(result, this.uploadFiles[i].file, true);

					response.subscribe({
						next: (uploadResult) => {
							this.externalShareService.postCheckinNew(this.token, uploadResult).subscribe(() => {
								if (i + 1 === this.uploadFormProperties.length) {
									this.loadShare();
								} else {
									this.doCreateUpload(i + 1);
								}
							});
						},
						error: err => {
							console.error(err);
							this.loading = false;
							this.toastr.error("An error occurred while uploading the file.");
						}
					});
				});
			} else {
				this.externalShareService.checkinNew(this.token, this.uploadFormProperties[i], this.uploadFiles[i].file).subscribe((result) => {
					if (i + 1 === this.uploadFormProperties.length) {
						this.loadShare();
					} else {
						this.doCreateUpload(i + 1);
					}
				});
			}
		});
	}

	startUpdate() {
		this.loading = true;
		this.formData = [];
		for (const prop of this.sharedItem.properties) {
			if (prop.editable) {
				if (prop.value.dataType === 9) {
					this.formData[prop.propertyDef] = prop.value.lookup.item;
					this.getOptionList(prop.propertyDef);
				} else if (prop.value.dataType === 10) {
					this.formData[prop.propertyDef] = JSON.parse(JSON.stringify(prop.value.lookups));
					this.getOptionList(prop.propertyDef);
				} else if (prop.value.dataType === 5 || prop.value.dataType === 6 || prop.value.dataType === 7) {
					this.formData[prop.propertyDef] = new Date(prop.value.value);
				} else {
					this.formData[prop.propertyDef] = prop.value.value;
				}
			}
		}

		this.editingProperties = true;
		this.editProperties = this.sharedItem.properties;
		if (this.optionListTotal === this.optionListLoaded) {
			this.loading = false;
		}
	}

	getOptionList(propertyDef: number) {
		if (!this.optionLists[propertyDef]) {
			this.optionLists[propertyDef] = [];
			this.optionListTotal = this.optionListTotal + 1;
			for (const prop of this.vaultProperties) {
				if (prop.id === propertyDef) {
					this.externalShareService.getValueListOptions(prop.valueList, this.token).subscribe((result) => {
						this.optionLists[propertyDef] = result.body;
						this.optionListLoaded = this.optionListLoaded + 1;
						if (this.optionListTotal === this.optionListLoaded) {
							this.loading = false;
							this.loadingProperties = false;
						}
					});
					break;
				}
			}
		}
	}

	cancelUpdate() {
		this.formData = [];
		this.editingProperties = false;
		this.editProperties = [];
	}

	saveUpdate() {
		this.loading = true;
		const submitProps = [];

		for (const prop of this.editProperties) {
			if (this.formData[prop.propertyDef]) {
				let value = this.formData[prop.propertyDef];
				if (prop.value.dataType === 10) {
					value = '';
					for (const option of this.formData[prop.propertyDef]) {
						value = value + option.id + ',';
					}
					if (value.length > 0) {
						value = value.substring(0, value.length - 1);
					}
				} else if (prop.value.dataType === 5 || prop.value.dataType === 6 || prop.value.dataType === 7) {
					value = new Date(value);
				}

				submitProps.push({ id: prop.propertyDef, dataType: prop.value.dataType, value: value });
			}
		}

		this.externalShareService.updateObject(this.token, this.sharedItem.type, this.sharedItem.id, submitProps).subscribe((result) => {
			this.loadShare();
		});
	}

	multiselectChanged(field: any, event: any) {
		let containsValue = false;

		if (!this.formData[field.propertyDef]) {
			this.formData[field.propertyDef] = [];
		} else {
			for (const value of this.formData[field.propertyDef]) {
				if (value.id === event.id) {
					containsValue = true;
				}
			}
		}

		if (!containsValue) {
			this.formData[field.propertyDef].push({ displayValue: event.name, id: event.id });
		}
	}

	removeMultiselect(field: any, i: number) {
		this.formData[field.propertyDef].splice(i, 1);
	}

	loadComments() {
		this.loadingComments = true;
		this.comments = [];
		this.displayTab = 'comments';
		this.externalShareService.getComments(this.token, this.sharedItem.id).subscribe((commentsResult) => {
			this.comments = commentsResult;
			this.setCommentsCount(this.comments);
			this.loadingComments = false;
		});
	}

	clearCommentForm() {
		this.newComment.comment = '';
	}

	onCommentSubmit() {
		this.loadingComments = true;

		this.externalShareService.postComment(this.token, this.sharedItem.id, null, this.newComment).subscribe((result) => {
			this.comments = result;
			this.setCommentsCount(this.comments);
			this.clearCommentForm();
			this.loadingComments = false;
		});
	}

	onNewComment(event: any) {
		this.loadingComments = true;

		this.externalShareService.postComment(this.token, this.sharedItem.id, event.parentComment, event).subscribe((result) => {
			this.comments = result;
			this.setCommentsCount(this.comments);
			this.loadingComments = false;
		});
	}

	prevFileClicked() {
		this.displayTab = 'viewer';
		let newDocumentIndex = this.selectedDocumentIndex;
		let newMemberIndex = this.selectedMemberIndex;
		let newFileIndex = this.selectedFileIndex;

		if (this.sharedItems[newDocumentIndex].files && newFileIndex !== 0) {
			newFileIndex = newFileIndex - 1;
		} else if (this.sharedItems[newDocumentIndex].members && newMemberIndex !== 0) {
			newMemberIndex = newMemberIndex - 1;
		} else {
			newDocumentIndex = newDocumentIndex - 1;
			if (this.sharedItems[newDocumentIndex].members) {
				newMemberIndex = this.sharedItems[newDocumentIndex].members.length - 1;
				newFileIndex = 0;
			} else if (this.sharedItems[newDocumentIndex].files) {
				newMemberIndex = 0;
				newFileIndex = this.sharedItems[newDocumentIndex].files.length - 1;
			}
		}

		this.externalObjectSelected(this.sharedItems[newDocumentIndex], newDocumentIndex, newMemberIndex, newFileIndex);
		this.pageService.setItemSelectedChanged({ id: this.sharedItems[newDocumentIndex].id, type: this.sharedItems[newDocumentIndex].type, version: this.sharedItems[this.selectedDocumentIndex].version });
	}

	nextFileClicked() {
		this.displayTab = 'viewer';
		let newDocumentIndex = this.selectedDocumentIndex;
		let newMemberIndex = this.selectedMemberIndex;
		let newFileIndex = this.selectedFileIndex;

		if (this.sharedItems[newDocumentIndex].files && newFileIndex + 1 < this.sharedItems[newDocumentIndex].files.length) {
			newFileIndex = newFileIndex + 1;
		} else if (this.sharedItems[newDocumentIndex].members && newMemberIndex + 1 < this.sharedItems[newDocumentIndex].members.length) {
			newMemberIndex = newMemberIndex + 1;
		} else {
			newDocumentIndex = newDocumentIndex + 1;
			newMemberIndex = 0;
			newFileIndex = 0;
		}
		this.externalObjectSelected(this.sharedItems[newDocumentIndex], newDocumentIndex, newMemberIndex, newFileIndex);
		this.pageService.setItemSelectedChanged({ id: this.sharedItems[newDocumentIndex].id, type: this.sharedItems[newDocumentIndex].type, version: this.sharedItems[this.selectedDocumentIndex].version });
	}

	loadViewer() {
		this.displayTab = 'viewer';
		this.externalObjectSelected(this.sharedItems[this.selectedDocumentIndex], this.selectedDocumentIndex, this.selectedMemberIndex, this.selectedFileIndex);
		this.pageService.setItemSelectedChanged({ id: this.sharedItems[this.selectedDocumentIndex].id, type: this.sharedItems[this.selectedDocumentIndex].type, version: this.sharedItems[this.selectedDocumentIndex].version });
	}

	closeViewerModal() {
		if (this.viewerModalRef) {
			this.viewerModalRef.hide();
			this.viewerModalRef = null;
		}

		this.pageService.viewerModalClosed.emit();
	}

	loadDocProperties() {
		this.loadingProperties = true;
		this.atLeastOneEditProp = false;
		this.docEditProps = [];
		this.externalShareService.getProperties(this.token, 0, this.sharedItems[this.selectedDocumentIndex].id, this.sharedItems[this.selectedDocumentIndex].version).subscribe((result: any) => {
			for (const prop of result.body.properties) {
				const editProp = {
					name: prop.name,
					id: prop.propertyDef,
					dataType: prop.value.dataType,
					value: prop.value.value,
					displayValue: prop.value.displayValue,
					editable: prop.editable && this.uneditableProps.indexOf(prop.propertyDef) === -1
				};
				if (editProp.editable) {
					this.atLeastOneEditProp = true;
				}
				if (editProp.dataType === 5 || editProp.dataType === 6 || editProp.dataType === 7) {
					editProp.value = new Date(prop.value.value);
				} else if (editProp.dataType === 9) {
					this.getOptionList(editProp.id);
					editProp.value = prop.value.lookup.item;
				} else if (editProp.dataType === 10) {
					this.getOptionList(editProp.id);
					editProp.value = [];
					for (const lookup of prop.value.lookups) {
						editProp.value.push({
							value: lookup.item,
							name: lookup.displayValue
						});
					}
				}
				this.docEditProps.push(editProp);
			}
			if (this.optionListTotal === this.optionListLoaded) {
				this.loadingProperties = false;
			}
		});
	}

	editMultiselectChanged(i: number, event: any) {
		let containsValue = false;

		if (!this.docEditProps[i].value) {
			this.docEditProps[i].value = [];
		} else {
			for (const value of this.docEditProps[i].value) {
				if (value.id === event.id) {
					containsValue = true;
				}
			}
		}

		if (!containsValue) {
			this.docEditProps[i].value.push({ value: event.id, name: event.name });
		}
	}

	removeEditMultiselectOption(prop: any, optionIndex: number) {
		prop.value.splice(optionIndex, 1);
	}

	removeProp(i: number) {
		this.docEditProps.splice(i, 1);
	}

	saveProperties() {
		this.loadingProperties = true;
		const submitProps = [];

		for (const prop of this.docEditProps) {
			let value = prop.value;
			if (prop.dataType === 10) {
				value = '';
				for (const option of prop.value) {
					value = value + option.value + ',';
				}
				if (value.length > 0) {
					value = value.substring(0, value.length - 1);
				}
			} else if (prop.dataType === 5 || prop.dataType === 6 || prop.dataType === 7) {
				value = new Date(value);
			}

			submitProps.push({ id: prop.id, dataType: prop.dataType, value: value });
		}

		this.externalShareService.updateObject(this.token, 0, this.sharedItems[this.selectedDocumentIndex].id, submitProps).subscribe((result) => {
			this.toastr.success('Successfully updated document properties');
			this.closeViewerModal();
			this.loadingProperties = false;
		});
	}

	externalFileRemoved(fileId: number) {
		this.loading = true;

		this.externalShareService.removeShareItem(this.token, fileId).subscribe((result) => {
			for (let i = 0; i < this.sharedItems.length; i++) {
				if (this.sharedItems[i].id === fileId) {
					this.sharedItems.splice(i, 1);
					break;
				}
			}
			this.loading = false;
		});
	}

	isFirstDoc() {
		return this.selectedDocumentIndex === 0 && this.selectedMemberIndex === 0 && this.selectedFileIndex === 0;
	}

	isLastDoc() {
		return this.selectedDocumentIndex == (this.sharedItems.length - 1) && (!this.sharedItems[this.selectedDocumentIndex].members || this.sharedItems[this.selectedDocumentIndex].members.length === this.selectedMemberIndex + 1) && (!this.sharedItems[this.selectedDocumentIndex].files || this.sharedItems[this.selectedDocumentIndex].files.length === this.selectedFileIndex + 1);
	}

	startLoad() {
		this.loading = true;
	}

	hasEditableMultiSelect() {
		let atLeastOne = false;

		for (const prop of this.docEditProps) {
			if (prop.editable && prop.dataType === 10) {
				atLeastOne = true;
				break;
			}
		}

		return atLeastOne;
	}


	isValidEmail(): boolean {
		const match = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return match.test(this.newComment.email) || !this.newComment.email?.length;
	}

	cancelDownload(doc: MFilesItem) {
		doc.cancelDownloadSubject.next(true);
		doc.downloading = false;
		doc.percentDownloaded = 0;
	}

	checkAll(shareDocs: any[], event: any) {
		for (const doc of shareDocs) {
			doc.checkedForDownload = event.target.checked;
		}
	}

	docIsChecked(doc: any): boolean {
		return this.selectedDocs.indexOf(doc) > -1;
	}

	downloadSelected(shareDocs: any[]) {
		this.loadingDownloadSelected = true;
		const docsToDownload: any[] = [];
		for (const doc of shareDocs) {
			doc.downloading = false;
			doc.percentDownloaded = 0;
			doc.cancelDownloadSubject = new Subject<boolean>();
			if (doc.checkedForDownload) {
				docsToDownload.push(doc);
			}
		}
		if (docsToDownload.length === 0) {
			this.toastr.info('Please select one or more documents to download.');
			this.loadingDownloadSelected = false;
		} else if (docsToDownload.length === 1) {
			this.downloadReportProgress(docsToDownload[0]);
			this.loadingDownloadSelected = false;
		} else if (docsToDownload.length > 1) {
			this.downloadMultipleReportProgress(docsToDownload);
			this.loadingDownloadSelected = false;
		}
	}

	atLeastOneDocChecked(shareDocs: any[]) {
		let isOneDocChecked = false;
		for (const doc of shareDocs) {
			if (doc.checkedForDownload) {
				isOneDocChecked = true;
				break;
			}
		}
		return isOneDocChecked;
	}

	downloadAll(shareDocs: any[]) {
		this.loadingDownloadAll = true;
		for (const doc of shareDocs) {
			doc.downloading = false;
			doc.percentDownloaded = 0;
			doc.cancelDownloadSubject = new Subject<boolean>();
		}
		this.downloadMultipleReportProgress(shareDocs);
		this.loadingDownloadAll = false;
	}

	downloadReportProgress(doc: any) {
		doc.downloading = true;

		this.externalShareService.download(this.token, 0, doc.id, 0, doc.version).pipe(
			takeUntil(doc.cancelDownloadSubject)
		).subscribe({
			next: (event) => {
				if (event.type === HttpEventType.DownloadProgress) {
					const percentDownloaded: number = (event.loaded / event.total) * 100;
					doc.percentDownloaded = percentDownloaded;
				}
				if (event.type === HttpEventType.Response) {
					saveAs(event.body, event.headers.get('filename'));
				}
			},
			error: (err) => {
				this.toastr.error('An error occurred while downloading ' + doc.title + '. Please try again later.');
				console.error(err);
			},
			complete: () => {
				doc.downloading = false;
				doc.percentDownloaded = 0;
			}
		});
	}

	downloadMultipleReportProgress(docs: any[]) {
		const docsCopy = [...docs];
		this.sortByFileSize(docsCopy);

		const observables: Observable<HttpEvent<Blob>>[] = [];
		docsCopy.forEach((doc) => {
			docs.find(item => item.id === doc.id).downloading = true;
			observables.push(this.externalShareService.download(this.token, 0, doc.id, 0, doc.version));
		});
		const subscriptions = from(observables).pipe(
			mergeMap((observable, i) => {
				return observable.pipe(
					takeUntil(docs.find(item => item.id === docsCopy[i].id).cancelDownloadSubject),
					map((event) => [event, docsCopy[i].id]),
					catchError((err) => {
						console.error(err);
						this.toastr.error('An error occurred while downloading ' + docsCopy[i].title + '. Please try again later.');
						return err;
					})
				);
			}, 3)
		).subscribe({
			next: ([event, id]: [HttpEvent<Blob>, number]) => {
				const doc: MFilesItem = docs.find(doc => doc.id === id);

				if (event.type === HttpEventType.DownloadProgress) {
					const percentDownloaded: number = (event.loaded / event.total) * 100;
					doc.percentDownloaded = percentDownloaded;
				}
				if (event.type === HttpEventType.Response) {
					saveAs(event.body, event.headers.get('filename'));
					doc.downloading = false;
					doc.percentDownloaded = 0;
				}
			},
			error: (err) => {
				console.error(err);
			},
			complete: () => {
				console.log(subscriptions);
			}
		});
	}

	sortByFileSize(docs: MFilesItem[]) {
		docs.sort((a, b) => {
			if (a !== null && a !== undefined && b !== null && b !== undefined) {
				if (a.files?.length === 1 && b.files?.length === 1) {
					return a.files[0].size - b.files[0].size;
				}
			}

			return 0;
		})
	}

	getColCount() {
		let colCount = 3; // related, download, and shareLink are always visible
		colCount = colCount + this.dataView.viewContents.columns.length;
		if (this.permissions.indexOf(6) > -1) {
			colCount = colCount + 1;
		}
		if (this.coauthorEnabled) {
			colCount = colCount + 1;
		}
		return colCount;
	}

	isDocsDownloading() {
		let isDocsDownloading = false;
		for (const sharedItem of this.sharedItems) {
			if (sharedItem.downloading) {
				isDocsDownloading = true;
			}
		}
		return isDocsDownloading;
	}

}

